// import $ from 'jquery';
import Jmt from 'jmt.js';
import Utils from 'utils';
import moment from 'moment';
import Awesomplete from 'awesomplete-es6';
import * as Ladda from 'ladda';


/**
 * Date Picker
 */
export class DatePicker {
    static momentRemoveZone(mObj) {
        return moment.utc(mObj.format('YYYY-MM-DD HH:mm'));
    }

    constructor(selector, options, onSelect) {
        // Set moment locale before anything else
        moment.locale('lv');

        this.selector = $(selector);
        this.onSelect = onSelect;
        this.pickerSettings = {
            minDate: false,
            maxDate: false,
            showWeekNumbers: false,
            timePicker: false,
            timePicker24Hour: true,
            timePickerIncrement: 1,
            singleDatePicker: true,
            showDropdowns: true,
            autoUpdateInput: false,
        };

        // Extend options with default options
        Object.assign(this.pickerSettings, options);

        // Add format
        if (typeof this.pickerSettings.locale === 'undefined') {
            this.pickerSettings.locale = {};
        }
        if (typeof this.pickerSettings.locale.format === 'undefined') {
            this.pickerSettings.locale.format = (this.pickerSettings.timePicker === true ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY');
        }

        this.selector.each((index, el) => {
            const $el = $(el);
            const unixFrom = parseInt($el.data('unix'), 10);
            if (unixFrom) {
                this.pickerSettings.startDate = moment.unix(unixFrom);
            } else if (typeof this.pickerSettings.startDate === 'number') {
                this.pickerSettings.startDate = moment.unix(this.pickerSettings.startDate);
            } else if (this.pickerSettings.startDate == null) {
                delete this.pickerSettings.startDate;
            }
            const unixTo = parseInt($el.data('unix_to'), 10);
            if (unixTo) {
                this.pickerSettings.endDate = moment.unix(unixTo);
            } else if (typeof this.pickerSettings.endDate === 'number') {
                this.pickerSettings.endDate = moment.unix(this.pickerSettings.endDate);
            } else if (this.pickerSettings.endDate == null) {
                delete this.pickerSettings.endDate;
            }

            $el.on('apply.daterangepicker', (ev, picker) => {
                this.pickerUpdateInput(ev, picker);
            });
            $el.daterangepicker(this.pickerSettings);
        });
    }

    pickerUpdateInput(ev, picker) {
        let start = picker.startDate;
        const end = picker.endDate;

        // Remove time zone if there is no time picker
        if (this.pickerSettings.timePicker === false) {
            start = DatePicker.momentRemoveZone(start);
        }

        // Update first input if this is not the input,
        // otherwise for some reason the value is not set
        let el = picker.element;
        if (picker.element.is(':input') === false) {
            el = $(picker.element).find('input:first');
        }

        if (this.pickerSettings.singleDatePicker === true) {
            el.val(start.format(picker.locale.format));
        } else {
            el.val(start.format(picker.locale.format)
                + picker.locale.separator
                + end.format(picker.locale.format));
        }

        // Callback
        if (typeof this.onSelect === 'function') {
            this.onSelect.call(this, picker.element, start, end, picker);
        }
    }
}


/**
 * Autocomplete
 */
export class AutoComplete extends Awesomplete {
    constructor(selector, options) {
        const el = $(selector);
        const defaultOptions = {
            autoFirst: true,
            data: (item) => {
                const title = this.formatItem(item);
                return { label: title, userData: item };
            },
            remoteReplace: (url, query) => url.replace('%query', encodeURIComponent(query)),
        };
        const cOptions = Object.assign(defaultOptions, options);

        // Check if there is an element to do the autocomplete on
        if (el.length === 0) {
            throw new Error(`Autocomplete: Selector not found: ${selector}`);
        }

        // Init
        super(el[0], cOptions);

        // Setup our custom stuff
        const parentClass = this;
        this.loading = false;
        el
            .on('keyup', function AutoCompleteKeyUpEvent(e) {
                // Stop esc propogation if autocomplete is open
                if (e.keyCode === 27 && typeof parentClass.stopEvent !== 'undefined' && parentClass.stopEvent === true) {
                    e.stopImmediatePropagation();
                    parentClass.stopEvent = false;
                }
            })
            .on('keyup', function AutoCompleteKeyUpEvent(e) {
                // Clear value
                if (this.value.length === 0) {
                    if (typeof parentClass.options.onClear === 'function') {
                        parentClass.options.onClear.call(parentClass);
                    }
                    return;
                }

                // Check for valid input
                if (
                    parentClass.loading === true
                    || Utils.isKeyCodeValidInput(e.keyCode) === false
                    || this.value.length < parentClass.minChars
                ) {
                    return;
                }

                // If we make any changes it makes sense to call the onClear event,
                // because the item is no longer selected
                if (typeof parentClass.options.onClear === 'function') {
                    parentClass.options.onClear.call(parentClass);
                }

                // Call remote
                let url = parentClass.options.remoteReplace(
                    parentClass.options.remoteUrl,
                    this.value
                );
                url += (url.indexOf('?') !== -1 ? '&' : '?');
                url += (new Date()).getTime();

                parentClass.loading = true;
                $.get(url, (data) => {
                    if (data && data.results) {
                        const items = data.results;
                        parentClass.list = items;
                    }
                })
                    .always(() => {
                        parentClass.loading = false;
                    });
            })
            .on('focus', function AutoCompleteFocusEvent() {
                const thisEl = this;
                setTimeout(
                    () => {
                        thisEl.select();
                    },
                    50
                );
            })
            .on('awesomplete-close', function (e) {
                if (e.originalEvent.reason === 'blur' || e.originalEvent.reason === 'esc') {
                    if (e.originalEvent.reason === 'esc') {
                        // This is here to prevent other windows from closing
                        parentClass.stopEvent = true;
                    }

                    // Clear the field out, because no item was selected
                    // and autocomplete was deliberately closed
                    parentClass.input.value = '';

                    // Call cancel event
                    if (typeof parentClass.options.onCancel === 'function') {
                        parentClass.options.onCancel.call(parentClass);
                    }
                }
            })
            .on('awesomplete-selectcomplete', (e) => {
                if (typeof parentClass.options.onSelect === 'function') {
                    parentClass.options.onSelect.call(
                        parentClass,
                        e.originalEvent.selectedSuggestion.userData,
                        e.originalEvent.selectedIndex
                    );
                }
            });
    }

    formatItem(item) {
        if (typeof this.options.formatLabel === 'function') {
            return this.options.formatLabel.call(this, item);
        }

        if (typeof this.options.formatLabel === 'string') {
            return item[this.options.formatLabel] || `Missing data key: ${this.options.formatLabel}`;
        }

        return item.text || 'Missing data key: text';
    }
}


/**
 * Options:
 *      postUrl
 *      addUrl
 *      editUrl
 *      deleteUrl
 *      addTemplate
 *      editTemplate
 */
export class Forms {
    static makeLaddaButton(button) {
        button.addClass('ladda-button');
        button.attr('data-style', 'slide-up');
        button.html(`<span class="ladda-label">${button.html()}</span>`);
    }

    constructor(additionalOptions) {
        const parentClass = this;

        this.options = {
            postUrl: null,
            addUrl: null,
            editUrl: null,
            detailsUrl: null,
            deleteUrl: null,

            addRecordTrigger: '#BasicForms_addRecord',
            editRecordTrigger: '.BasicForms_editRecord',
            removeRecordTrigger: '.BasicForms_removeRecord',

            addTemplate: 'BasicForms_addTemplate',
            editTemplate: null,

            addTemplateData: {},
            editTemplateData: {},

            onFormShow() { },
            onErrorReceived() { },

            size: 'small',

            addButtons: [],
            editButtons: [],
        };

        // Extend options with default options
        Object.assign(this.options, additionalOptions);

        if (this.options.addUrl === null) {
            this.options.addUrl = this.options.postUrl;
        }
        if (this.options.editUrl === null) {
            this.options.editUrl = this.options.postUrl;
        }
        if (this.options.detailsUrl === null) {
            this.options.detailsUrl = this.options.editUrl;
        }
        if (this.options.deleteUrl === null) {
            this.options.deleteUrl = this.options.postUrl;
        }

        const addTemplate = (
            this.options.addTemplate !== 'BasicForms_addTemplate' || $('#BasicForms_addTemplate').length > 0 ? new Jmt(this.options.addTemplate) : null
        );
        const editTemplate = (
            this.options.editTemplate === null && $('#BasicForms_editTemplate').length === 0 ? addTemplate : new Jmt('BasicForms_editTemplate')
        );

        // TODO: throw new Error(`Template not found`);

        $(document).on('click', this.options.addRecordTrigger, (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            const addButton = $(e.currentTarget);
            const html = addTemplate.html(this.options.addTemplateData);

            ((form) => {
                let acceptButtonActivity = null;
                const box = mainModule.bootbox.confirm({
                    size: form.options.size,
                    title: 'Pievienot ierakstu',
                    message: html,
                    closeButton: false,
                    show: false,
                    buttons: {
                        cancel: {
                            label: '<i class="fa fa-times mr-2"></i>Atcelt',
                        },
                        confirm: {
                            label: '<i class="fa fa-check mr-2"></i>Saglabāt',
                        },
                    },
                    callback(result) {
                        if (result === true) {
                            const wrapper = box.find('.bootbox-body');
                            const postData = wrapper.find(':input').serialize();
                            acceptButtonActivity.start();
                            wrapper.find('.errors').addClass('d-none');
                            $.post(form.options.addUrl, postData, (data) => {
                                // Check response
                                if (data.msg && data.msg.code !== 0) {
                                    setTimeout(() => {
                                        acceptButtonActivity.stop();
                                    }, 200);
                                    wrapper.find('.errors').removeClass('d-none').html(data.msg.text);

                                    // On error
                                    form.options.onErrorReceived.call(parentClass, box, data);
                                    return;
                                }

                                // Reload the page
                                window.location.reload();
                            })
                                .fail(() => {
                                    setTimeout(() => {
                                        acceptButtonActivity.stop();
                                    }, 200);
                                });

                            return false;
                        }

                        return true;
                    },
                });

                box.on('shown.bs.modal', () => {
                    box.find(':input[type!=hidden]:first:not(.datepicker):not(.datetimepicker):not(.dateintervalpicker)').focus();
                    const acceptButton = box.find('.bootbox-accept');
                    if (acceptButton.length > 0) {
                        Forms.makeLaddaButton(acceptButton);
                        acceptButtonActivity = Ladda.create(acceptButton[0]);
                    }

                    form.options.onFormShow.call(parentClass, box, addButton, 'add');
                });

                box.modal('show');
            })(this);
        });

        // Edit trigger
        ((form) => {
            $(document).on('click', form.options.editRecordTrigger, function FormsEditRecordTrigger(e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                const editButton = $(this);
                let activity = null;

                if (editButton.hasClass('ladda-button')) {
                    activity = Ladda.create(this);
                    activity.start();
                }

                $.post(form.options.detailsUrl, { get_item: editButton.data('id') }, (detailsData) => {
                    if (detailsData.item) {
                        const templateData = Object.assign(
                            parentClass.options.editTemplateData,
                            detailsData.item
                        );
                        const html = editTemplate.html(templateData);
                        let acceptButtonActivity = null;
                        const box = mainModule.bootbox.confirm({
                            size: form.options.size,
                            title: 'Labot ierakstu',
                            message: html,
                            closeButton: false,
                            show: false,
                            buttons: {
                                cancel: {
                                    label: '<i class="fa fa-times mr-2"></i>Atcelt',
                                },
                                confirm: {
                                    label: '<i class="fa fa-check mr-2"></i>Saglabāt',
                                },
                            },
                            callback(result) {
                                if (result === true) {
                                    const wrapper = box.find('.bootbox-body');
                                    const postData = wrapper.find(':input').serialize();
                                    acceptButtonActivity.start();
                                    wrapper.find('.errors').addClass('d-none');
                                    $.post(form.options.editUrl, postData, (data) => {
                                        // Check response
                                        if (data.msg && data.msg.code !== 0) {
                                            setTimeout(() => {
                                                acceptButtonActivity.stop();
                                            }, 200);
                                            wrapper.find('.errors').removeClass('d-none').html(data.msg.text);

                                            form.options.onErrorReceived.call(
                                                parentClass,
                                                box,
                                                data
                                            );
                                            return;
                                        }

                                        // Reload the page
                                        window.location.reload();
                                    })
                                        .fail(() => {
                                            setTimeout(() => {
                                                acceptButtonActivity.stop();
                                            }, 200);
                                        });

                                    return false;
                                }

                                return true;
                            },
                        });

                        box.on('shown.bs.modal', () => {
                            box.find(':input[type!=hidden]:first:not(.datepicker):not(.datetimepicker):not(.dateintervalpicker)').focus();
                            const acceptButton = box.find('.bootbox-accept');
                            if (acceptButton.length > 0) {
                                Forms.makeLaddaButton(acceptButton);
                                acceptButtonActivity = Ladda.create(acceptButton[0]);
                            }

                            form.options.onFormShow.call(parentClass, box, editButton, 'edit');
                        });

                        box.modal('show');
                    } else if (detailsData.msg) {
                        Utils.showAlert('Kļūda', detailsData.msg.text);
                    }
                })
                    .done(() => {
                        if (activity !== null) {
                            setTimeout(() => {
                                activity.stop();
                            }, 200);
                        }
                    });
            });
        })(this);

        ((form) => {
            $('.table').on('click', form.options.removeRecordTrigger, function FormsRemoveRecordTrigger(e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                const removeButton = $(this);
                const html = '<p class="text-center">Vai tiešām dzēst šo ierakstu?</p>';
                let acceptButtonActivity = null;
                const box = mainModule.bootbox.confirm({
                    size: 'small',
                    title: 'Dzēst',
                    message: html,
                    closeButton: false,
                    show: false,
                    buttons: {
                        cancel: {
                            label: '<i class="fa fa-times mr-2"></i>Atcelt',
                        },
                        confirm: {
                            label: '<i class="fa fa-check mr-2"></i>Apstiprināt',
                            className: 'btn-danger',
                        },
                    },
                    callback(result) {
                        if (result === true) {
                            const wrapper = box.find('.bootbox-body');
                            acceptButtonActivity.start();
                            wrapper.find('.errors').addClass('d-none');
                            $.post(
                                form.options.deleteUrl,
                                { delete_item: removeButton.data('id') },
                                (responseData) => {
                                    // Check response
                                    if (responseData.msg && responseData.msg.code !== 0) {
                                        setTimeout(() => {
                                            acceptButtonActivity.stop();
                                        }, 200);
                                        Utils.showAlert('Kļūda', responseData.msg.text, 'error');

                                        form.options.onErrorReceived.call(
                                            parentClass,
                                            box,
                                            responseData
                                        );
                                        return;
                                    }

                                    // Reload the page
                                    window.location.reload();
                                }
                            )
                                .fail(() => {
                                    setTimeout(() => {
                                        acceptButtonActivity.stop();
                                    }, 200);
                                });

                            return false;
                        }

                        return true;
                    },
                });

                box.on('shown.bs.modal', () => {
                    box.find(':input[type!=hidden]:first').focus();
                    const acceptButton = box.find('.bootbox-accept');
                    if (acceptButton.length > 0) {
                        Forms.makeLaddaButton(acceptButton);
                        acceptButtonActivity = Ladda.create(acceptButton[0]);
                    }

                    form.options.onFormShow.call(parentClass, box, removeButton, 'remove');
                });

                box.modal('show');
            });
        })(this);
    }
}


// File upload
export class FileUploads {
    static fileTypeMapping() {
        return {
            pdf: 'fa-file-pdf-o',
            xls: 'fa-file-excel-o',
            xlsx: 'fa-file-excel-o',
            doc: 'fa-file-word-o',
            docx: 'fa-file-word-o',
            ppt: 'fa-file-powerpoint-o',
            pptx: 'fa-file-powerpoint-o',
            zip: 'fa-file-archive-o',
            rar: 'fa-file-archive-o',
            tar: 'fa-file-archive-o',
            gz: 'fa-file-archive-o',
            '7z': 'fa-file-archive-o',
            gzip: 'fa-file-archive-o',
            bz2: 'fa-file-archive-o',
            tgz: 'fa-file-archive-o',
            jpg: 'fa-file-image-o',
            jpeg: 'fa-file-image-o',
            png: 'fa-file-image-o',
            gif: 'fa-file-image-o',
            bmp: 'fa-file-image-o',
            tiff: 'fa-file-image-o',
            psd: 'fa-file-image-o',
            ai: 'fa-file-image-o',
            mp3: 'fa-file-audio-o',
            m4a: 'fa-file-audio-o',
            ogg: 'fa-file-audio-o',
            aac: 'fa-file-audio-o',
            flac: 'fa-file-audio-o',
            oga: 'fa-file-audio-o',
            wav: 'fa-file-audio-o',
            txt: 'fa-file-text-o',
            c: 'fa-file-code-o',
            h: 'fa-file-code-o',
            cpp: 'fa-file-code-o',
            php: 'fa-file-code-o',
            py: 'fa-file-code-o',
            java: 'fa-file-code-o',
            webm: 'fa-file-video-o',
            mkv: 'fa-file-video-o',
            flv: 'fa-file-video-o',
            ogv: 'fa-file-video-o',
            avi: 'fa-file-video-o',
            wmv: 'fa-file-video-o',
            mp4: 'fa-file-video-o',
            mpg: 'fa-file-video-o',
            mpeg: 'fa-file-video-o',
            mp4v: 'fa-file-video-o',
        };
    }

    static mapExtension(extension) {
        if (typeof FileUploads.fileTypeMapping[extension] !== 'undefined') {
            return FileUploads.fileTypeMapping[extension];
        }
        return 'fa-file-o';
    }

    constructor(wrapper, options) {
        const parentClass = this;
        this.wrapper = $(wrapper);

        this.itemsWrapper = this.wrapper.find('.basic_forms-file_upload-items_wrapper');
        this.input = this.wrapper.find('.basic_forms-file_upload-file_input');
        this.uploadButton = this.wrapper.find('.basic_forms-file_upload-upload_button');
        this.commentsInput = this.wrapper.find('.basic_forms-file_upload-comments_input');
        this.progress = this.wrapper.find('.progress');
        this.progressBar = this.progress.find('.progress-bar');
        this.errors = this.wrapper.find('.errors');
        this.errorsLabel = this.errors.find('label');
        this.inputFieldName = (options && typeof options.inputName !== 'undefined' ? options.inputName : 'files');
        this.currentFile = 0;
        this.filesToUpload = [];
        this.fileItemTemplate = new Jmt(`<tr class="file-item"><td class="text-center"><input type="hidden" name="${this.inputFieldName}[]" value="<%=id%>"><span class="fa <%=typeClass%>"></span></td><td><a target="_blank" href="${BASE_URL}file-manager/manager/download/<%=name%>"><%=original_name%></a></td><td><%=comments%></td><td class="text-center"><a href="#" class="BasicForms_removeFile" data-name="<%=name%>"><span class="glyphicon glyphicon-remove text-danger"></span></a></td></tr>`);

        // DOM events
        this.input.on('change', function FileManagerInputChangeEvent() {
            const { files } = this;
            if (files.length > 0) {
                parentClass.currentFile = 0;
                parentClass.filesToUpload = files;
                if (parentClass.uploadButton.length === 0) {
                    parentClass.uploadFile();
                }
            }
        });

        this.uploadButton.on('click', () => {
            if (parentClass.filesToUpload.length > 0) {
                parentClass.uploadFile();
            }
        });


        // Load all files, already in context
        $.post(`${BASE_URL}file-manager/manager/files/${encodeURIComponent(this.wrapper.data('context'))}`, (data) => {
            if (typeof data.files !== 'undefined') {
                Object.keys(data.files).forEach((key) => {
                    const file = data.files[key];
                    file.typeClass = FileUploads.mapExtension(file.extension);

                    const html = parentClass.fileItemTemplate.html(file);
                    parentClass.itemsWrapper.append(html);
                });
            }
        });


        // Delete files
        this.wrapper.on('click', '.BasicForms_removeFile', function formsRemoveFileClick(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const removeButton = $(this);
            Utils.showConfirm('Brīdinājums', 'Vai tiešām dzēst šo failu?', (success, box) => {
                if (success === true) {
                    const acceptButton = box.find('.bootbox-accept');
                    if (acceptButton.length > 0) {
                        Forms.makeLaddaButton(acceptButton);
                        const acceptButtonActivity = Ladda.create(acceptButton[0]);
                        acceptButtonActivity.start();
                    }

                    $.post(`${BASE_URL}file-manager/manager/delete-file/${removeButton.data('name')}`, () => {
                        const itemDOM = removeButton.parents('.file-item:first');
                        itemDOM.fadeOut(() => {
                            itemDOM.remove();
                        });
                    });
                }
            }, 'danger');
        });
    }

    uploadFile() {
        if (this.currentFile === 0) {
            this.progress.removeClass('d-none');
            this.input.addClass('d-none');
        }

        if (this.currentFile > this.filesToUpload.length - 1) {
            return;
        }

        const formData = new FormData();
        formData.append('file', this.filesToUpload[this.currentFile]);
        formData.append('comments', this.commentsInput.val());
        formData.append('context', this.wrapper.data('context'));
        formData.append('category', this.wrapper.data('category'));

        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${BASE_URL}file-manager/manager/upload`);

        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const complete = (event.loaded / event.total * 100 || 0);
                this.progressBar
                    .css('width', `${complete}%`)
                    .html(`${complete}% ${(this.currentFile + 1)}/${this.filesToUpload.length}`);
            }
        };

        xhr.onerror = () => {
            this.requestFinished(true);
            this.errorsLabel.html('Connection error.');
        };

        xhr.onload = () => {
            if (xhr.status === 200) {
                let response = null;
                try {
                    response = JSON.parse(xhr.responseText);
                } catch (e) {
                    this.errorsLabel.html('Couldn\'t parse response data. Please try again later or something.');
                    this.requestFinished(true);
                    return;
                }

                if (typeof response.error !== 'undefined' && response.error.code !== 0) {
                    this.errorsLabel.html(response.error.msg);
                    this.requestFinished(true);
                    return;
                }

                if (typeof response.file !== 'undefined') {
                    const { file } = response;
                    file.typeClass = FileUploads.mapExtension(file.extension);

                    const html = this.fileItemTemplate.html(file);
                    this.itemsWrapper.append(html);
                }
                this.requestFinished(false);
            } else {
                this.errorsLabel.html('Something went terribly wrong. Please try again later or something.');
                this.requestFinished(true);
            }
        };

        this.progressBar.removeClass('d-none');
        this.input.addClass('d-none');

        xhr.send(formData);
    }

    requestFinished(stop) {
        if (this.currentFile === this.filesToUpload.length - 1 || stop === true) {
            this.input.removeClass('d-none');
            this.progress.addClass('d-none');
            this.progressBar
                .css('width', '100%')
                .html(`100% ${(this.currentFile + 1)}/${this.filesToUpload}.length`);
            this.input.val('');
            this.commentsInput.val('');
        } else {
            this.currentFile += 1;
            this.uploadFile();
        }
    }
}


// Table Filters
export class TableFilters {
    constructor(options) {
        const parentClass = this;
        this.filterBlock = $(options.filterBlock);
        this.filterUrl = options.filterUrl;
        this.filterTable = this.filterBlock.parents('table:first');

        // Check if there is an element to do the TableFilters on
        if (this.filterBlock.length === 0) {
            throw new Error(`Autocomplete: Selector not found: ${options.filterBlock}`);
        }

        this.filterBlock.find('input.filter').on('keyup', function (e) {
            if (e.keyCode === 13) {
                e.stopImmediatePropagation();
                parentClass.submitFilter();
            }
        });

        this.filterBlock.find(':input.filter').on('change', function (e) {
            if ($(this).data('filter_stop') !== true) {
                e.stopImmediatePropagation();
                parentClass.submitFilter();
            }
        });

        // Dates
        new DatePicker(this.filterBlock.find('.datepicker'), { autoApply: true });
        new DatePicker(this.filterBlock.find('.datetimepicker'), { timePicker: true, autoApply: true });
        new DatePicker(this.filterBlock.find('.dateintervalpicker'), { singleDatePicker: false, autoApply: true });

        this.filterBlock.find('.filter').on('apply.daterangepicker', function (e) {
            e.stopImmediatePropagation();

            let el = $(this);
            if (el.is('input') === false) {
                el = el.find('input:first');
            }

            el.data('value', el.val());
            parentClass.submitFilter();
        });

        // Multiselect
        this.filterBlock.find('select[multiple=multiple]')
            .on('shown.bs.select', function () {
                $(this).data('filter_stop', true);
                $(this).data('before_value', $(this).val().join(','));
            })
            .on('hidden.bs.select', function () {
                $(this).data('filter_stop', false);

                if ($(this).data('before_value') !== $(this).val().join(',')) {
                    $(this).trigger('change');
                }
            })
            .selectpicker({
                noneSelectedText: 'Izvēlies',
                selectAllText: 'Izvēlies visus',
                // buttonText: (choices) => {
                //     if (choices.length === 0) {
                //         return 'Izvēlies';
                //     }

                //     if (choices.length > 3) {
                //         return 'Vairāk par 3 iespējām!';
                //     }

                //     const labels = [];
                //     choices.each(function () {
                //         if ($(this).attr('label') !== undefined) {
                //             labels.push($(this).attr('label'));
                //         } else {
                //             labels.push($(this).html());
                //         }
                //     });

                //     return `${labels.join(', ')}`;
                // },
            });

        // Autocomplete
        this.filterBlock.on('awesomplete-selectcomplete', () => {
            parentClass.submitFilter();
        });

        // Select *
        this.filterBlock.find('.parent_checkbox').on('click', function () {
            parentClass.filterBlock.parents('table:first').find('input.child_checkbox').prop('checked', $(this).prop('checked'));
        });

        // Submit
        // TODO: Rename submit_filter event to submit-filter
        this.filterBlock.on('submit_filter', function () {
            parentClass.submitFilter();
        });
    }

    submitFilter() {
        const filter = [];
        this.filterBlock.find('.filter').each(function (index, el) {
            let value = $(el).data('value');
            if (value == null || value === '') {
                value = $(el).val();
            }

            if (value != null && value !== '') {
                filter.push(`${el.id.replace('filter_', '')}=${encodeURIComponent(value)}`);
            }
        });
        const newUrl = this.filterUrl.replace('%filter', filter.join(';'));
        window.location.href = newUrl;
    }

    registerQuickFilter() {
        const parentClass = this;

        this.filterTable.find('span.quick-filter').on('click', function (e) {
            e.stopImmediatePropagation();

            const thisSpan = $(this);
            const eventCol = thisSpan.parents('td:first');
            const index = eventCol.index();
            const filterObj = parentClass.filterBlock.find(`td:eq(${index}) .filter`);

            filterObj.val($(this).data('value'));
            filterObj.trigger('change');
        });
    }
}
